(function () {
  window.Torras = window.Torras || {};

  function hydrateCardImages(card) {
    card.querySelectorAll('[data-card-deferred-src]').forEach(function (image) {
      var srcset = image.getAttribute('data-card-deferred-srcset');
      if (srcset) image.setAttribute('srcset', srcset);
      image.setAttribute('src', image.getAttribute('data-card-deferred-src'));
      image.removeAttribute('data-card-deferred-src');
      image.removeAttribute('data-card-deferred-srcset');
    });
  }

  function initProductCardSwatches(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('.product-card-wrapper, .fh-product-card[data-fh-curated-product-card]');

    Array.prototype.forEach.call(cards, function (card) {
      if (card.dataset.swatchesInitialized === 'true') return;

      var buttons = card.querySelectorAll('[data-swatch-button]');
      if (!buttons.length) {
        hydrateCardImages(card);
        return;
      }
      var baseProductUrl = card.getAttribute('data-card-product-url') || '';
      var cardInner = card.querySelector('[data-card-inner-link]');
      var productLinks = card.querySelectorAll('[data-card-product-link]');
      var variantInput = card.querySelector('[data-card-variant-input]');
      var shopNowButton = card.querySelector('[data-card-shop-now]');
      var shopNowLabel = card.querySelector('[data-card-shop-now-label]');
      var soldOutMessage = shopNowButton ? shopNowButton.querySelector('.sold-out-message') : null;

      function updateCardImages(src, imageWidth) {
        if (!src) return;
        Array.prototype.forEach.call(card.querySelectorAll('.card__media img, .fh-product-card__media img, [data-card-image]'), function (image) {
          if (image.closest('noscript')) return;
          var responsiveWidths = image.getAttribute('data-card-responsive-widths');
          if (responsiveWidths) {
            var maximumWidth = Number(imageWidth) || 720;
            var widths = responsiveWidths.split(',').map(Number).filter(function (width) { return width <= maximumWidth; });
            if (!widths.length) widths = [maximumWidth];
            var srcset = widths.map(function (width) {
              var candidate = new URL(src, window.location.origin);
              candidate.searchParams.set('width', width);
              return candidate.href + ' ' + width + 'w';
            }).join(', ');
            image.setAttribute('srcset', srcset);
          } else {
            image.srcset = '';
          }
          image.src = src;
          image.removeAttribute('data-card-deferred-src');
          image.removeAttribute('data-card-deferred-srcset');
        });
      }

      function buildVariantUrl(variantId) {
        if (!baseProductUrl || !variantId) return baseProductUrl;

        var url = new URL(baseProductUrl, window.location.origin);
        url.searchParams.set('variant', variantId);
        return url.pathname + url.search + url.hash;
      }

      function updateCardLinks(variantUrl) {
        if (!variantUrl) return;
        if (cardInner) cardInner.setAttribute('data-card-inner-link', variantUrl);
        Array.prototype.forEach.call(productLinks, function (link) {
          link.setAttribute('href', variantUrl);
        });
      }

      function updateAddToCart(button) {
        if (!button) return;

        var variantId = button.getAttribute('data-variant-id') || '';
        var isAvailable = button.getAttribute('data-variant-available') === 'true';

        card.dataset.selectedVariantId = variantId;
        if (variantInput) {
          variantInput.value = variantId;
          variantInput.disabled = !variantId || !isAvailable;
        }

        if (!shopNowButton) return;
        shopNowButton.disabled = !variantId || !isAvailable;
        shopNowButton.setAttribute('aria-disabled', !variantId || !isAvailable ? 'true' : 'false');

        if (shopNowLabel) {
          shopNowLabel.classList.remove('hidden');
          shopNowLabel.textContent = isAvailable
            ? shopNowButton.getAttribute('data-available-label') || shopNowLabel.textContent
            : shopNowButton.getAttribute('data-sold-out-label') || shopNowLabel.textContent;
        }
        if (soldOutMessage) soldOutMessage.classList.add('hidden');
      }

      function setSwatchState(button) {
        if (!button) return;

        Array.prototype.forEach.call(buttons, function (sibling) {
          sibling.classList.remove('is-active');
          sibling.setAttribute('aria-pressed', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        updateCardImages(button.getAttribute('data-image-src'), button.getAttribute('data-image-width'));
        updateCardLinks(buildVariantUrl(button.getAttribute('data-variant-id')));
        updateAddToCart(button);
      }

      function trackSwatchSelection(button) {
        if (!button || !button.dataset.analyticsElementId) return;
        window.TorrasAnalytics?.trackInteraction(button, {
          elementType: 'variant_option',
          elementId: button.dataset.analyticsElementId,
          elementPosition: button.dataset.analyticsElementPosition,
          interactionName: 'select_variant',
          interactionResult: 'success'
        });
      }

      Array.prototype.forEach.call(buttons, function (button) {
        function applySwatchState(event) {
          if (event) {
            event.preventDefault();
            event.stopPropagation();
          }
          setSwatchState(button);
          if (event && event.type !== 'mouseenter') trackSwatchSelection(button);
        }

        button.addEventListener('mouseenter', applySwatchState);
        button.addEventListener('click', applySwatchState);
        button.addEventListener('touchstart', applySwatchState, { passive: false });
      });

      var initialButton =
        Array.prototype.find.call(buttons, function (button) {
          return button.classList.contains('is-active');
        }) || buttons[0];
      if (card.hasAttribute('data-card-random-initial-swatch')) {
        var availableButtons = Array.prototype.filter.call(buttons, function (button) {
          return button.getAttribute('data-variant-available') === 'true';
        });
        var imageButtons = availableButtons.filter(function (button) {
          return button.hasAttribute('data-swatch-has-variant-image');
        });
        var randomButtons = imageButtons.length ? imageButtons : availableButtons;
        if (randomButtons.length) {
          initialButton = randomButtons[Math.floor(Math.random() * randomButtons.length)];
        }
      }
      setSwatchState(initialButton);
      hydrateCardImages(card);
      card.dataset.swatchesInitialized = 'true';
    });
  }

  function initProductCardInnerLinks(root) {
    var scope = root || document;
    var cardInners = scope.querySelectorAll('.product-card-wrapper .card__inner[data-card-inner-link]');

    Array.prototype.forEach.call(cardInners, function (cardInner) {
      if (cardInner.dataset.cardInnerLinkBound === 'true') return;

      function goToProduct(event) {
        var target = event && event.target ? event.target : null;
        if (target && target.closest('a, button, input, select, textarea, summary, details, label')) return;

        var href = cardInner.getAttribute('data-card-inner-link');
        if (!href) return;

        window.location.href = href;
      }

      cardInner.addEventListener('click', goToProduct);
      cardInner.style.cursor = 'pointer';
      cardInner.dataset.cardInnerLinkBound = 'true';
    });
  }

  window.Torras.initProductCards = function initProductCards(root) {
    initProductCardSwatches(root);
    initProductCardInnerLinks(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.Torras.initProductCards(document);
    });
  } else {
    window.Torras.initProductCards(document);
  }
})();
